module.exports = __webpack_public_path__ + "media/components/src/assets/images/glasses/glasses-1ae2c8d9dfaf4a2d541214ca52346d6f.svg";